import React from 'react';
import { connect } from 'react-redux';
// Grid imports
/*
    Using sortable hoc by clauderic to create the level item grid. 

    For more information and help, see:
    https://github.com/clauderic/react-sortable-hoc
*/
import { sortableContainer } from 'react-sortable-hoc';
// GameGuide imports
import LevelItem from './levelItem';
// Game(kit) imports
import gameKit from '../../../../GameKit';

const LevelsGrid = sortableContainer(({ items }) => {
    return (
        <div className="level-items">
            {items.map((value, idx) => (
                <LevelItem key={value.uuid} index={idx} uuid={value.uuid} thumbnail={value.thumbnail} description={value.description} />
            ))}
        </div>
    );
});

class LevelItems extends React.Component {
    constructor(props) {
        super(props);
        this.draggedItem = undefined;
        this.lastHoveredItem = undefined;
        this.levelItems = [];
    }

    handleSortEnd = ({ oldIndex, newIndex }) => {
        const { game } = this.props;
        const { levels } = game;

        gameKit.moveLevel(levels[oldIndex].uuid, newIndex);
    };

    render() {
        const { game } = this.props;
        const { levels } = game;

        const levelGrid =
            levels.length > 0 ? <LevelsGrid items={levels} axis="y" onSortEnd={this.handleSortEnd} /> : <p className="grid-desc">Hier kun je levels bouwen, verschuiven en verwijderen.</p>;

        return <div id="level-item-grid">{levelGrid}</div>;
    }
}

LevelItems.defaultProps = {};

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    game: state.game
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LevelItems);
